export const selectDefaultMapType = (state): string => {
  return state.ui.profile.defaultMapType || 'roadmap';
};

export const selectHasUnlimitedUnlocks = (state): boolean => state.ui.profile.hasUnlimitedUnlocks;

export const selectShowTableView = (state): boolean => state.ui.showTableView;

export const selectShowMap = (state): boolean => state.ui.showMap;

export const selectOffMarketSearch = (state): boolean => state.ui.offMarketSearch;

export const selectCallListTableView = (state): boolean => state.ui.callListTableView;

export const selectLoading = (state): boolean => state.ui.loading;

export const selectStaticCallList = (state): boolean => state.ui.staticCallList;
